module.exports = {"1":"ひどい","2":"期待以下","3":"まあまあ","4":"ほぼ満足","5":"優良","1.5":"ひどい","2.5":"期待以下","3.5":"まあまあ","4.5":"優良"}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/resources/localization/ja-JP/star-ratings.json
// module id = 1314
// module chunks = 0